import { render } from "./choices.vue?vue&type=template&id=70465bb3"
import script from "./choices.vue?vue&type=script&lang=js"
export * from "./choices.vue?vue&type=script&lang=js"

import "./choices.vue?vue&type=style&index=0&id=70465bb3&lang=scss"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__